import { actionType } from "../actions/internkoderIleggelserActions";
import * as reducerUtils from "../utils/reducerUtils";

const INITIAL_STATE = [];
const internkoderIleggelserReducer = (state = INITIAL_STATE, action) =>
  reducerUtils.CreateNewReducer(state, action, actionType);

export default internkoderIleggelserReducer;
